# how to use this small helper
# to activate set this:
#   data-behaviour="reload-page"
#
# options:
#   data-selector - default: .content-wrapper (any css selector know by jquery)
#   data-timeout  - default: 10000 (in miliseconds)
#
timeout = null
initReload = ->
  reloadPage = $('[data-behaviour="reload-page"]')
  window.clearTimeout timeout if timeout
  timeout = null
  if reloadPage.length > 0
    selector = reloadPage.data('selector') || '.content-wrapper'
    timeout = window.setTimeout ->
      content = $(selector)
      scrollTop = content.scrollTop()
      $.get window.location.href, ( data, textStatus, jqXHR ) ->
        newContent = $(data).find(selector)
        content.replaceWith(newContent)
        newContent.scrollTop(scrollTop)
        $(document).trigger 'reload:done'
    , parseInt(reloadPage.data('timeout')) || 10000

$(initReload)
$(document).on 'reload:done', initReload
